import { Shield } from "lucide-react";

export const PrivacyPolicy = () => {
  const lastUpdated = "April 25, 2026";

  return (
    <div className="min-h-screen pt-28 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-3xl mx-auto" data-testid="privacy-policy-page">
        <div className="flex items-center gap-3 mb-2">
          <Shield className="h-8 w-8 text-emerald-600" />
          <h1 className="text-4xl font-bold text-gray-900">Privacy Policy</h1>
        </div>
        <p className="text-sm text-gray-500 mb-10">Last updated: {lastUpdated}</p>

        <div className="prose prose-emerald max-w-none space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">1. Introduction</h2>
            <p>
              Raffy's Cuisine ("we", "us", or "our") respects your privacy and is committed to
              protecting the personal information you share with us. This Privacy Policy explains
              what information we collect, how we use it, and your rights regarding that
              information when you visit raffyscuisine.com or place an order with us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">2. Information We Collect</h2>
            <p>We collect the following information when you place an order or contact us:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name, email address, and phone number</li>
              <li>Delivery address (street, city, state, ZIP code)</li>
              <li>Order details (items, quantities, special instructions)</li>
              <li>Payment information (processed securely by Square — we never store your full card number)</li>
              <li>Catering inquiry details, if you submit our catering form</li>
              <li>Account credentials, if you create a customer account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>To process and deliver your orders</li>
              <li>To send order confirmations and status updates</li>
              <li>To respond to catering inquiries and customer support requests</li>
              <li>To calculate delivery fees based on your address</li>
              <li>To improve our menu, service, and website</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">4. Payment Processing</h2>
            <p>
              Payments are processed by Square, Inc. We never see or store your full card number,
              CVV, or expiration date. Square is PCI-DSS compliant. For details, please review{" "}
              <a
                href="https://squareup.com/us/en/legal/general/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-600 hover:text-emerald-700 underline"
              >
                Square's Privacy Notice
              </a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">5. Information Sharing</h2>
            <p>We do not sell your personal information. We share data only with:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Square</strong> — to process your payment</li>
              <li><strong>Email service providers</strong> — to send order confirmations</li>
              <li><strong>Delivery personnel</strong> — name, address, phone for delivery only</li>
              <li><strong>Law enforcement</strong> — when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">6. Cookies and Local Storage</h2>
            <p>
              We use browser local storage to remember your cart between visits. We do not use
              third-party advertising or tracking cookies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">7. Data Retention</h2>
            <p>
              Order records are retained for tax and accounting purposes (typically 7 years per
              Texas requirements). You may request deletion of your account and personal information
              at any time by emailing us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">8. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Access the personal information we hold about you</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion (subject to legal retention requirements)</li>
              <li>Opt out of marketing communications at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">9. Children's Privacy</h2>
            <p>
              Our service is not intended for individuals under 13. We do not knowingly collect
              information from children.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The "Last updated" date at the
              top reflects the most recent revision.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">11. Contact Us</h2>
            <p>For privacy questions or requests, contact us at:</p>
            <ul className="list-none pl-0 space-y-1">
              <li><strong>Email:</strong> chefwegotittx@gmail.com</li>
              <li><strong>Phone:</strong> (682) 402-3734</li>
              <li><strong>Business:</strong> Raffy's Cuisine, Fort Worth, TX</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};
